<template>
  <div class="mdm_group_page">
    <h3 class="title-page">{{ $t("category") }}</h3>
    <div>
      <div class="admin_container product-category-container">
        <div class="product-category_head_block">
          <div class="report_contract_form">
            <div class="form_c_up division_form align-center">
              <div>
                <custom-input-text
                  :label="$t('searchByName')"
                  :loading="searchLoading"
                  :placeholder="$t('name')"
                  class="for_icon_after"
                  @input="searchCategories"
                ></custom-input-text>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mb-4">
          <v-btn color="primary" @click="createCategoryShowHandler">
            <!--            <v-icon>mdi-plus</v-icon>-->
            {{ $t("create") }}
          </v-btn>
        </div>
        <div class="table_attribute_block">
          <div class="table_head_name d-flex justify-space-between">
            <div class="head_name_block">{{ $t("name") }}</div>
            <div class="action_block">{{ $t("action") }}</div>
          </div>
          <custom-treeview
            v-if="ready"
            ref="treeTable"
            :items="items"
            :load-children="fetchItems"
            item-children="child"
          >
            <template #append="{ item }">
              <div class="append_icon_category" style="width: 800px">
                <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.type === ItemTypeKey.category"
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click.stop="itemAddHandler(item)"
                    >
                      <vue-icon icon="newPlusIcon" />
                    </v-btn>
                  </template>
                  <span>{{ $t("addProduct") }}</span>
                </v-tooltip>

                <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="item.type === ItemTypeKey.category"
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click.stop="itemEditHandler(item)"
                    >
                      <vue-icon icon="newPencilIcon" />
                    </v-btn>
                  </template>
                  <span>{{ $t("edit") }}</span>
                </v-tooltip>
                <v-tooltip color="#fff" left nudge-right="10" nudge-top="35">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click.stop="itemDeleteHandler(item)"
                    >
                      <vue-icon icon="newTrashIcon" />
                    </v-btn>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </v-tooltip>
              </div>
            </template>
          </custom-treeview>
        </div>
      </div>
    </div>
    <CategoryProductFormDialog
      @closeDialog="closeDialog"
      v-model="formDialog"
      :form-data.sync="formData"
      :groups="groups"
      :isOnlyCategory.sync="isOnlyCategory"
      :isProductForm.sync="isProductForm"
      :types="types"
      :unitTypes="unitTypes"
      @save="onSave"
    ></CategoryProductFormDialog>
    <WarningDialog
      ref="confirmDeleteDialog"
      v-model="deleteDialog"
      @apply="confirmDeleteHandler"
    ></WarningDialog>
  </div>
</template>

<script>
import CustomTreeview from "../../../components/Treeview/CustomTreeview";
import WarningDialog from "../../../components/ui/prompt/warning-dialog";
import CategoryProductFormDialog from "../../../components/reference/product-type/form-dialog";
import { categoryKey } from "@/utils/constants";
import { debounce } from "@/utils/pureFunctions";

const ItemTypeKey = {
  category: "Type",
  product: "Product",
};

export default {
  components: { WarningDialog, CustomTreeview, CategoryProductFormDialog },
  data() {
    return {
      searchLoading: false,
      deleteDialog: false,
      formDialog: false,
      isOnlyCategory: false,
      items: [],
      types: [],
      groups: [],
      unitTypes: [],
      ready: true,
      ItemTypeKey,
      configuration: {
        limit: 10,
        page: 1,
        lastPage: 1,
      },
      isProductForm: true,
      editedItem: null,
      formData: {
        name_uz: "",
        name_ru: "",
        name_en: "",
        id: null,
        typeId: null,
        parentId: null,
        product_group_id: null,
      },
    };
  },

  methods: {
    closeDialog() {
      this.formDialog = false;
    },
    async itemEditHandler(item) {
      this.isProductForm = item.type !== ItemTypeKey.category;
      if (this.isProductForm) {
        const {
          data: {
            data: {
              productPackageType: packageType,
              group_id: product_group_id,
              type_id: typeId,
            },
          },
        } = await this.$http.get("product/getBy-id", {
          params: { id: item.id },
        });
        item = { ...item, packageType, product_group_id, typeId };
      }
      this.formDialog = true;
      this.formData = { ...item, typeId: item.parentId };
      this.editedItem = item;
    },
    itemAddHandler(item) {
      this.formData.typeId = item.id;
      this.formData.parentId = item.id;
      this.editedItem = item;
      this.formDialog = true;
      this.isOnlyCategory = false;
    },
    itemDeleteHandler(item) {
      this.formData = { ...item };
      this.deleteDialog = true;
    },
    createCategoryShowHandler() {
      this.isOnlyCategory = true;
      this.isProductForm = false;
      this.formDialog = true;
    },
    async fetchItems(item) {
      const { treeTable } = this.$refs;
      return new Promise((resolve) => {
        item.loading = true;
        this.$http
          .get("product-type/list", {
            params: {
              parentId: item.id,
            },
          })
          .then(({ data: { data } }) => {
            if (data.length) {
              item.child = data.map((obj, index) => {
                if (obj.type === ItemTypeKey.category) {
                  obj.child = [];
                  obj.parentId = item.id;
                  obj.loading = false;
                } else {
                  delete obj.child;
                  obj.unitTypeIds = obj.unitTypes.map((unitType) => {
                    return `${unitType.id}`;
                  });
                }
                item.key = `${item.id}-${index}${item.name}`;
                return obj;
              });
            } else {
              item.child = [
                {
                  name: this.$t("itIsEmpty"),
                  key: `No-data-${item.id}`,
                  disabled: true,
                },
              ];
            }
            treeTable.init();
          })
          .catch((e) => {
            this.setResponseError({ error: e });
          })
          .finally(() => {
            item.loading = false;
            resolve();
          });
      });
    },
    searchCategories: debounce(async function (name) {
      this.searchLoading = true;
      await this.getCategories(name, true);
      this.searchLoading = false;
    }, 500),
    async getCategories(name) {
      function getData(items, allId) {
        if (items) {
          items.forEach((item) => {
            allId.push(item.id);
            getData(item.child);
          });
        }
      }

      let params = {};
      if (name) {
        params["name"] = name;
      }
      try {
        this.ready = false;
        const {
          data: { data },
        } = await this.$http.get("product-type/list", { params });
        this.items = data.map((item, index) => {
          if (item.type === ItemTypeKey.category) {
            item.loading = false;
          }
          item.key = `${item.id}-${index}${item.name}`;
          return item;
        });
        this.ready = true;
        this.$nextTick(() => {
          const { treeTable } = this.$refs;
          treeTable.init();
          if (name) {
            const allId = [];

            getData(data, allId);
            treeTable.open = allId;
          }
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getAllTypes() {
      try {
        const { data } = await this.$store.dispatch("getProductTypes");
        this.types = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getGroups() {
      try {
        const { data } = await this.$store.dispatch("getProductGroups");
        this.groups = data;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async confirmDeleteHandler() {
      try {
        const { confirmDeleteDialog } = this.$refs;
        confirmDeleteDialog.setLoading(true);
        if (this.formData.type === categoryKey) {
          await this.$http.delete("product-type/delete", {
            params: { id: this.formData.id },
          });
        } else {
          await this.$http.delete("product/delete", {
            params: { id: this.formData.id },
          });
        }
        confirmDeleteDialog.setLoading(false);
        this.showLoading();
        await this.getCategories();
        this.clearLoading();
        this.setSuccess({
          text: this.$t("successfullyDeleted"),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getUnitTypes() {
      try {
        this.unitTypes = await this.$store.dispatch("getUnitTypeList");
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async onSave() {
      await this.getCategories();
      this.formDialog = false;
    },
  },
  async mounted() {
    this.showLoading();
    await this.getCategories();
    await this.getAllTypes();
    await this.getGroups();
    await this.getUnitTypes();
    this.clearLoading();
  },
};
</script>
